import comp from "./LeFeed";
export default comp;
